var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4680_6744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.17471 22.1892C5.36634 22.3815 5.51318 22.6138 5.60476 22.8694C5.69634 23.125 5.73042 23.3976 5.70456 23.6679C5.57481 24.9188 5.32882 26.1549 4.96979 27.3602C7.54517 26.7639 9.1181 26.0735 9.83256 25.7116C10.2378 25.5064 10.7045 25.4577 11.1433 25.575C12.4014 25.9104 13.698 26.0792 14.9999 26.0772C22.3772 26.0772 27.923 20.895 27.923 15.0002C27.923 9.1073 22.3772 3.9233 14.9999 3.9233C7.62271 3.9233 2.07687 9.1073 2.07687 15.0002C2.07687 17.7104 3.21594 20.2248 5.17471 22.1892ZM4.26456 29.3984C3.82715 29.4851 3.38832 29.5645 2.94825 29.6365C2.57902 29.6956 2.29841 29.3116 2.44425 28.9682C2.60817 28.5816 2.75842 28.1894 2.89471 27.7922L2.90025 27.7738C3.3581 26.4445 3.73102 24.9159 3.86764 23.4925C1.60241 21.2218 0.230713 18.2495 0.230713 15.0002C0.230713 7.863 6.84364 2.07715 14.9999 2.07715C23.1563 2.07715 29.7692 7.863 29.7692 15.0002C29.7692 22.1375 23.1563 27.9233 14.9999 27.9233C13.5371 27.9253 12.0804 27.7353 10.667 27.3584C9.70702 27.8439 7.64117 28.7282 4.26456 29.3984Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4680_6744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.5385,
    height: 29.5385,
    fill: "white",
    transform: "translate(0.230713 0.230957)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageChat);
export default __webpack_public_path__ + "static/media/message_chat.6d846fcf8efc30434ba45d76eaf9ed51.svg";
export { ForwardRef as ReactComponent };